<template>
    <Section
        class="banner bg-cream"
        width="sm"
    >
        <div class="banner-inner">
            <h1 class="banner-inner__title">{{ $prismic.asText(data.primary.h1) }}</h1>
            <div
                v-if="$validateText(data.primary.teaser)"
                class="banner-inner__teaser list-icon rich-text rich-text-list-green"
                v-html="$prismic.asHtml(data.primary.teaser)"
            /> 
            <button class="btn btn-md btn-green">
                <a v-scroll-to="'#question-form'" href="#">
                    {{ $translate('qa_ask_question_cta', 'Ställ din fråga') }}
                </a>
            </button>
        </div>
    </Section>
</template>

<script>
export default {
    props: {
        data: {
            type: Object,
            required: true
        }
    }
};
</script>

<style lang="scss" scoped>
.banner::v-deep {

    text-align: center;
    h1 {
        color: $green;
        width: 100%;
    }

    .banner-inner {
        @include flex;
        .banner-inner__teaser {
            :first-child {
                margin-top: 0;
            }
            :last-child {
                margin-bottom: 0;
            }
            ul {
                text-align: left;
            }
        }
        button {
            @include spacing(margin,5,top);
            @include spacing(padding,8,(left, right));
            a {
                text-decoration: none;
                color: $white;
            }
        }
    }
}
</style>